import produce from 'immer'
import { Reducer } from 'redux'
import * as UserTypes from './User.types'

export const userServiceInitialState: UserTypes.UserServiceState = {
  entity: null,
  candidate: null,
  updateLists: null,
  npsModalDisplayed: false,
  rateUsPopupDismissed: false
}

export const userReducer: Reducer<UserTypes.UserServiceState, UserTypes.UserServiceActions> = (
  state = userServiceInitialState,
  action
): UserTypes.UserServiceState =>
  produce(state, (draft) => {
    switch (action.type) {
      case UserTypes.UserServiceActionTypes.SET_USER: {
        draft.entity = action.user
        return
      }

      case UserTypes.UserServiceActionTypes.SET_USER_ONBOARDING_COMPLETED: {
        if (draft.entity) {
          draft.entity.onboardingCompleted = true
        }
        return
      }

      case UserTypes.UserServiceActionTypes.DISSMISS_RATE_US_POPUP: {
        draft.rateUsPopupDismissed = true
        return
      }

      case UserTypes.UserServiceActionTypes.SET_NPS_MODAL_DISPLAYED: {
        draft.npsModalDisplayed = action.displayed
        return
      }

      case UserTypes.UserServiceActionTypes.SET_USER_NPS_MODAL_COMPLETED: {
        if (draft.entity) {
          draft.entity.npsPopupCompleted = action.completed
        }
        return
      }

      case UserTypes.UserServiceActionTypes.SET_USER_PT_LEAD_MODAL_COMPLETED: {
        if (draft.entity) {
          draft.entity.ptTrialInvitePopupCompleted = action.completed
        }
        return
      }

      case UserTypes.UserServiceActionTypes.UPDATE_USER_PROFILE: {
        if (draft.entity) {
          draft.entity.profile = {
            ...draft.entity.profile,
            ...action.userProfile,
            avatar: action.userProfile.avatar
          }
        }
        return
      }

      case UserTypes.UserServiceActionTypes.SET_USER_NOTIFICATIONS_SETTINGS: {
        if (draft.entity) {
          draft.entity.notificationSettings = action.notificationSettings
        }
        return
      }

      case UserTypes.UserServiceActionTypes.SET_USER_SOUND_SETTINGS: {
        if (draft.entity) {
          draft.entity.soundEffectsEnabled = action.soundEffectsEnabled
        }
        return
      }

      case UserTypes.UserServiceActionTypes.UPDATE_USER: {
        if (draft.entity) {
          draft.entity = { ...draft.entity, ...action.data }
        }
        return
      }

      case UserTypes.UserServiceActionTypes.LOGOUT: {
        draft = {
          candidate: null,
          entity: null,
          npsModalDisplayed: false,
          rateUsPopupDismissed: false,
          updateLists: draft.updateLists
        }
        return
      }

      case UserTypes.UserServiceActionTypes.SET_UPDATE_LIST: {
        draft.updateLists = action.lists
        return
      }

      case UserTypes.UserServiceActionTypes.SET_CANDIDATE: {
        draft.candidate = action.candidate
        return
      }

      default:
        return state
    }
  })
